import {Link,Navigate} from 'react-router-dom'; 
import React, {useEffect,useState, useRef } from "react";
import axios from "axios";
import { FcHome, FcOrgUnit,FcCandleSticks, FcAutomotive} from "react-icons/fc";
import { FiMenu } from 'react-icons/fi';
import { GrPower } from "react-icons/gr";
import { API_URL} from "../components/constants";
import BGImage from '../images/race-bg.jpg';
 

interface WrapperProps {
    children?: React.ReactNode;
    msisdn:string;
  }
  
  const Wrapper: React.FC<WrapperProps> = ({ children}) => {
    axios.defaults.withCredentials = true;
    const [redirect, setRedirect] = useState(false);
 

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
  
    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    };
  
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };
  
    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    useEffect(  () =>{
        (
         async () => {
            try {
                const {data} = await axios.get(`${API_URL}/appUser`);
                //const {data} = await axios.get(`${API_URL}/user`);
                //console.log(data.msisdn);
                if(data.msisdn === ""){

                }
                 
            } catch (error) {
                
                setRedirect(true);
            }
            
         }
        )();
      }, []);

      const logout = async () =>{
        await axios.post(`${API_URL}/logout`,{});
        setRedirect(true);
      }
     
      if(redirect){
        return <Navigate to={'/login'} />;
      }
    return (<>
   <div className="min-h-screen " >
             {/* Top Navigation Bar */}
      <div className="bg-black text-white flex space-x-4 hidden top-0 md:flex items-center justify-center">
        
        <div className="my-4">
        <Link
             className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    
                    
                    <FcHome className="ml-8" />
                    <span className="ml-2">Play</span>
                </Link>
        </div>

        <div className="my-4">
        <Link
             className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/race"}
                >
                    <FcAutomotive/>
                    <span className="ml-2">Race</span>
                </Link>
        </div>

        <div className="my-4">
        <Link
             className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/topup"}
                >
                    <FcCandleSticks />
                    <span className="ml-2">TopUp</span>
                </Link>
        </div>


            <div className="my-4">
                <Link className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/withdraw"}
                >
                    <FcOrgUnit />
                    <span className="ml-2">Withdraw</span>
                </Link>
            </div>

            <div className="my-4">
                <Link className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/login"}  onClick={logout}
                >
                    <GrPower />
                    <span className="ml-2">Log Out</span>
                </Link>
            </div>

         
      </div>


        {/* Hamburger Icon */}
       

      {/* Hamburger Icon for Mobile */}
      <div className="flex items-center justify-center md:hidden">
        <button onClick={toggleMenu}>
          <FiMenu className="text-3xl" />
        </button>
      </div>

      {/* Side Drawer Menu */}
      <div
        ref={menuRef}
        className={`bg-gray-800 text-white z-50 transform ${
          isMenuOpen ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0 md:bg-transparent md:static md:flex md:items-center md:justify-center md:w-1/3 absolute top-0 left-0 h-screen overflow-y-auto`}
      >
        {/* Menu Items */}
        <nav className="text-white">
            <ul>
        <li className="py-2"> <Link
             className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    
                    
                    <FcHome className="ml-8" />
                    <span className="ml-2">Play</span>
                </Link></li>
            <li className="py-2"> <Link
             className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/race"}
                >
                    <FcAutomotive className="ml-8" />
                    <span className="ml-2">Race</span>
                </Link></li>
            <li className="py-2"><Link
             className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/topup"}
                >
                    <FcCandleSticks className="ml-8"  />
                    <span className="ml-2">TopUp</span>
                </Link></li>
            <li className="py-2"> <Link className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/withdraw"}
                >
                    <FcOrgUnit className="ml-8 "  />
                    <span className="ml-2 mr-8">Withdraw</span>
                </Link></li>

                <li className="py-2"> 
                <Link className="inline-flex items-center w-full text-sm font-semibold text-white transition-colors duration-150 hover:text-yellow-500 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/login"}  onClick={logout}
                >
                    <GrPower className="ml-8" />
                    <span className="ml-2">Logout</span>
                </Link>
                </li>

          </ul>
        </nav>
      </div>
 


      {/* Content Div */}
      <div className="flex flex-col items-center mt-8 bg-cover bg-center bg-no-repeat fixed top-5 left-0 w-full h-full z-10 opacity-90" style={{
        backgroundImage: `url(${BGImage})`, // Replace with your image path
      }}>
      
       {/* Pass msisdn prop to children */}
       {children}
      </div>
    </div>

   
    </>);
};

export default Wrapper;